<template>
	<div class="row">
		<table class="table border table-bordered">
			<tbody>
				<tr>
					<td rowspan="32" class='align-middle'><span v-html="getInfo([],'root')"></span></td>
					<td rowspan="16" class="align-middle"><span v-html="getInfo(['male'], '-')"></span></td>
					<td rowspan="8" class="align-middle"><span v-html="getInfo(['father'])"></span></td>
					<td rowspan="4" class="align-middle"><span v-html="getInfo(['father','father'])"></span></td>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['father','father','father'])"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','father','father','father'])"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','father','father','mother'])"></span></td>
				</tr>
				<tr>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['father','father','mother'])"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','father','mother','father'])"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','father','mother','mother'])"></span></td>
				</tr>
				<tr>
					<td rowspan="4" class="align-middle"><span v-html="getInfo(['father','mother'])"></span></td>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['father','mother','father'])"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','mother','father','father'])"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','mother','father','mother'])"></span></td>
				</tr>
				<tr>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['father','mother','mother'])"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','mother','mother','father'])"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','mother','mother','mother'])"></span></td>
				</tr>
				<tr>
					<td rowspan="8" class="align-middle"><span v-html="getInfo(['mother'])"></span></td>
					<td rowspan="4" class="align-middle"><span v-html="getInfo(['mother','father'])"></span></td>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['mother','father','father'])"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','father','father','father'])"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','father','father','mother'])"></span></td>
				</tr>
				<tr>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['mother','father','mother'])"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','father','mother','father'])"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','father','mother','mother'])"></span></td>
				</tr>
				<tr>
					<td rowspan="4" class="align-middle"><span v-html="getInfo(['mother','mother'])"></span></td>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['mother','mother','father'])"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','mother','father','father'])"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','mother','father','mother'])"></span></td>
				</tr>
				<tr>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['mother','mother','mother'])"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','mother','mother','father'])"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','mother','mother','mother'])"></span></td>
				</tr>
				<!---                  -->
				<tr>
					<td rowspan="16" class="align-middle"><span v-html="name(pedigree.female)"></span></td>
					<td rowspan="8" class="align-middle"><span v-html="getInfo(['father'], 'female')"></span></td>
					<td rowspan="4" class="align-middle"><span v-html="getInfo(['father','father'], 'female')"></span></td>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['father','father','father'], 'female')"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','father','father','father'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','father','father','mother'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['father','father','mother'], 'female')"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','father','mother','father'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','father','mother','mother'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="4" class="align-middle"><span v-html="getInfo(['father','mother'], 'female')"></span></td>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['father','mother','father'], 'female')"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','mother','father','father'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','mother','father','mother'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['father','mother','mother'], 'female')"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','mother','mother','father'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['father','mother','mother','mother'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="8" class="align-middle"><span v-html="getInfo(['mother'], 'female')"></span></td>
					<td rowspan="4" class="align-middle"><span v-html="getInfo(['mother','father'], 'female')"></span></td>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['mother','father','father'], 'female')"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','father','father','father'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','father','father','mother'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['mother','father','mother'], 'female')"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','father','mother','father'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','father','mother','mother'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="4" class="align-middle"><span v-html="getInfo(['mother','mother'], 'female')"></span></td>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['mother','mother','father'], 'female')"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','mother','father','father'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','mother','father','mother'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="2" class="align-middle"><span v-html="getInfo(['mother','mother','mother'], 'female')"></span></td>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','mother','mother','father'], 'female')"></span></td>
				</tr>
				<tr>
					<td rowspan="1" class="align-middle"><span v-html="getInfo(['mother','mother','mother','mother'], 'female')"></span></td>
				</tr>
			</tbody>
		</table>
	</div>
</template>


<script>
import axios from 'axios'

export default {
	name: 'Pedigree',
	props: ['id',],
	data() {
		return {
			pedigree: [],
		}
	},
	methods: {
		name(param) {
			try {
				return param['name']
			} catch (e) { return "-" }
		},
		getInfo(params, sex='male'){
			try {
				var obj = ''
				if (sex == '-') {
					obj=this.pedigree[params[0]]
				} else if (sex == 'root') {
					return "<h1>"+this.pedigree.name+"</h1>"
				} else {
					obj = this.pedigree[sex]
					console.log('obj', obj)
					for (var i in params){
						obj = obj[params[i]]
					}
				}
				var result = ""
				if (params[params.length-1] == 'father' || params[params.length-1] == 'male') {
					result += "<span class='text-info'>"
				} else {
					result += "<span class='text-danger'>"
				}
				
				result += obj.name+"<br>"+obj.color+"<br>"+obj.birthday+"<br>"+obj.county_of_origin
				result += "</span>"
				return result
			} catch (e) { return "-"}

		},
		getPedigree(id){
			var url = 'http://catahoulakennel.ru/api/v1/pedigree/pedigreeinfo/'+id+'/'
			axios.get(url)
			.then(response => { 
				//console.log(response['data'])
				this.pedigree = response['data']
			})
		}
	},
	created() {
		this.getPedigree(this.id)
	}

}

</script>


